import DetailsGrid from './DetailsGrid';
import DetailsStack from './DetailsStack';
import DetailsElegantColumns from './DetailsElegantColumns';

const VARIANTS = {
  'details-grid': DetailsGrid,
  'details-stack': DetailsStack,
  'details-elegant-columns': DetailsElegantColumns,
};

export default function EventDetailsSection({ section, data, theme, settings }) {
  const Variant = VARIANTS[section.variant] || DetailsGrid;
  return <Variant section={section} data={data} theme={theme} settings={settings} />;
}
